import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Loading from '../components/Loading';
import { Box, Typography } from '@mui/material';

export const ErrorScreen = () => {
    //Route only is hit when a users profile cannot be retrieved.

    return (
        <Box>
            <Typography>Profile Error Happened</Typography>
        </Box>
    );
};

export default withAuthenticationRequired(ErrorScreen, {
    onRedirecting: () => <Loading />,
});
